import Logo, { LogoNameType } from '../Logo';
import { Text } from '../Text';

export type QuoteTileProps = {
  logo: LogoNameType;
  quote: string;
  authorName: string;
  authorTitle: string;
};

export const QuoteTile = ({ logo, quote, authorName, authorTitle }: QuoteTileProps) => (
  <div className="size-full flex flex-col gap-2xs">
    <div className="h-6 flex items-center">
      <Logo type={logo} isFullColor />
    </div>
    <Text type="p2-medium" as="p" className="text-primary">{quote}</Text>
    <div>
      <Text type="caption2" as="p" className="text-primary">{authorName}</Text>
      <Text type="caption2" as="p" className="text-secondary">{authorTitle}</Text>
    </div>
  </div>
);
